import { TripRequestLogSource, TripRequestLogStatus } from '../enums';

export interface ITripRequestLogOutputDto {
    id?: string;
    method: string;
    routePath: string;
    organizationId?: string;
    timestamp: Date;
    statusCode: number;
    status: TripRequestLogStatus;
    source?: TripRequestLogSource;
    tripDefinition?: string;
    tripDefinitionName?: string;
    tripCode?: string;
    trip?: string;
    userId?: string;
    userName?: string;
    apiKey?: string;
    requestBody?: Record<string, unknown>;
    responseBody?: Record<string, unknown>;
    createdAt?: string;
    updatedAt?: string;
}
